import React, { Component } from 'react'
import { Container } from 'components/Layout'
import HeadingBanner from 'components/Text/HeadingBanner'
import JoinAccountForm from '../JoinAccountForm'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'
import sLay from 'styles/modules/layout.scss'

import IconThumb from 'components/Icons/Thumb'

export default class JoinAccount extends Component {
  afterSubmit = () => {
    const { push, showBillingCreateFormModal } = this.props
    push('/dashboard')
    showBillingCreateFormModal()
  }

  prev = () => {
    const { push } = this.props
    push('/login')
  }

  render() {
    return (
      <div>
        <HeadingBanner filled>
          <IconThumb size={70} />
          <h3 className={cn(sText.heading3, sText.accent)}>We know this is a Big Dill</h3>
          <div className={sText.descrip2}>We're going to be great together!</div>
        </HeadingBanner>

        <Container
          className={cn(sAnim.comeUp, 'sm', sLay['layout-column'], sLay.flex)}
          paddingBottom
          paddingTop
        >
          <JoinAccountForm afterSubmit={this.afterSubmit} prev={this.prev} prevText="Back" />
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/JoinAccount/JoinAccount.jsx